import { graphqlPost } from '@/libs/tpm-analytics/graphql/transport';
import { buildShiftScrapRecordsQuery, toIsoString } from '@/libs/tpm-analytics/graphql/queries';
import { buildShiftScrapRecordsWhere } from '@/libs/tpm-analytics/graphql/predicates';

/**
 * Repository for reading shift scrap records.
 */
export class ScrapRecordsRepository {
    static async fetchShiftScrapRecords(
        fromIso: string,
        toIso: string,
        filters?: { locationIds?: string[]; workplaceIds?: string[]; projectIds?: string[]; shiftTypeIds?: string[]; shiftTeamTypeIds?: string[] }
    ): Promise<any[]> {
        const where = buildShiftScrapRecordsWhere(filters);
        const query = buildShiftScrapRecordsQuery(where);
        const data = await graphqlPost<any>(query, { from: toIsoString(fromIso), to: toIsoString(toIso) });
        const list: any[] = data?.shiftScrapRecords ?? [];
        return list;
    }
}


